import React from "react";
//import PropTypes from "prop-types";
import { i18n } from "react-i18n";
import {
	Alert,
	Button,
	Glyph,
	Loader,
	Spinner,
	Row,
	Col,
	Container,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Table,
	Card,
	Select
} from "kepler";

let currentYear = new Date().getFullYear();
let startYear = 2017;
let controlOptions = [];
let z = 0;
for (var i=startYear;i<=currentYear;i++){
	controlOptions.push({
        label: i, 
        value:  i
    });
}
export default class GiftAidDeclaration extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			modalIsOpen: false,
			removeGAState: false,
			giftAidStatus: "enabled",
			loader: false,
			charityDeclMsg: this.props.content,
			gaEnabled: this.props.gaEnabled,
			gaDisabled: this.props.gaDisabled,
			tableResult: false,
			selectedYear: new Date().getFullYear(),
			searchResultArrays: {}
		};
		this.toggleModal = this.toggleModal.bind(this);
		this.removeGiftAid = this.removeGiftAid.bind(this);
		this.loadDeclarationPage = this.loadDeclarationPage.bind(this);
		this.getgiftAidResults = this.getgiftAidResults.bind(this);
	}

	componentDidMount() {
		if($('#giftAidReportTable')){
			let year = this.state.selectedYear;
			this.getgiftAidResults(year);
		}
	}

	getgiftAidResults(year){
		let self = this,
			csrf = $("body").attr("data-csrf"),
			data = {
				preference: false,
				_csrf: csrf,
				year: year
			};
			self.setState({
				loader: true,
				selectedYear:year
			});
			$.post("/givingfund/giftaid/getresults", data, function(result) {
				if (result.searchResults.length > 0){
					self.setState({
						loader: false,
						tableResult: true,
						searchResultArrays: result.searchResults
					});
				} else {
					self.setState({
						loader: false,
						tableResult: false,
					});
				}
			}).fail(function() {
				self.setState({
					loader: false
				});
				$(".errorMsg").show();
			});
	}


	toggleModal(visible) {
		this.setState({
			modalIsOpen: visible
		});
	}

	loadDeclarationPage() {
		this.setState({
			removeGAState: false,
			giftAidStatus: "disabled"
		});
	}

	removeGiftAid() {
		let self = this,
			csrf = $("body").attr("data-csrf"),
			data = {
				preference: false,
				_csrf: csrf
			};
		self.setState({
			loader: true
		});
		$.post("/givingfund/giftaid/charitydecl", data, function(result) {
			if (result.giftAidStatus === "false") {
				self.setState({
					loader: false,
					modalIsOpen: false,
					removeGAState: true,
					gaDisabled: true
				});
			} else {
				self.setState({
					loader: false,
					modalIsOpen: true,
					removeGAState: false,
					gaEnabled: true
				});
				$(".errorMsg").show();
			}
		}).fail(function() {
			self.setState({
				loader: false
			});
			$(".errorMsg").show();
		});
	}
	render() {
		var self = this;
		let removeGA = this.state.removeGAState,
			giftAidStatus = this.state.giftAidStatus,
			charityDeclMsg = this.state.charityDeclMsg,
			gaDisabled = this.state.gaDisabled,
			gaEnabled = this.state.gaEnabled,
			tableResult = this.state.tableResult;
			let results = this.state.searchResultArrays;
			let resultsList;
			if(tableResult == true) {
				resultsList = results.map(function(result, index){
					let filename=result.file_name.split(".");
					let URL = "/givingfund/downloadGiftAidDocument?claimId="+result.id+"&type=CSV";
                    return <tr><td className="left">{filename[0]} Gift Aid Contributions </td><td className="left"><a href={URL} className="csvdownload">Download</a></td></tr>						
                });
			}
		return (
			<Container>
				<Loader
					show={this.state.loader}
					priority={10}
					type="fixed"
					size="lg"
					opacity="0.5"
				/>
				{removeGA ? (
					<Container
						id="giftAidCharityWapper"
						maxWidth={800}
						className="container"
					>
						<Row>
							<Card id="setupConfirmation" className="roundedBox">
								<div className="outerContainer">
									<div className="iconHolder">
										<Glyph
											icon="icon-circled-checkmark-large"
											type="success"
											size="large"
										/>
									</div>
									<h2>{charityDeclMsg.giftAidDisabled}</h2>
									<Button
										id="disableGASuccess"
										onClick={this.loadDeclarationPage}
										className="btnLink"
									>
										{charityDeclMsg.done}
									</Button>
								</div>
							</Card>
						</Row>
					</Container>
				) : (
					<div>
						<h2 className="title" id="gaTitle">{charityDeclMsg.declarations}</h2>
						<Card id="giftAidReport">
							<Row>
								<Col sm="2/3">
									<Select
										value={this.state.inputSelect}
										options={controlOptions}
										onChange={this.getgiftAidResults}
										className="yearSelect"
										label={this.state.selectedYear}
									/>
								</Col>
								<Col sm="1/3">
									{gaDisabled ? (
										<div className="text-right">
											<span className="borderRight">
												<strong>
													{charityDeclMsg.status}
												</strong>
												{charityDeclMsg.giftAidDisabledMsg}
											</span>
											<Button
												id="enableGaAction"
												type="link"
												onClick={
													this.props
														.loadGiftAidEnablePage
												}
											>
												{charityDeclMsg.enable}
											</Button>
										</div>
									) : (
										<div className="text-right">
											<span className="borderRight">
												<strong>
													{charityDeclMsg.status}
												</strong>
												{charityDeclMsg.giftAidEnabledMsg}
											</span>
											<Button
												id="disableGaAction"
												type="link"
												onClick={this.toggleModal}
											>
												{charityDeclMsg.disable}
											</Button>
										</div>
									)}
								</Col>
							</Row>
							<Table id="giftAidReportTable">
								<colgroup>
									<col width="70%" />
									<col width="30%" />
								</colgroup>
								<thead>
									<tr>
										<th>{charityDeclMsg.headerMonth}</th>
										<th>{charityDeclMsg.headerCSV}</th>
									</tr>
								</thead>
								<tbody>
									{(tableResult == true) ?
										 resultsList 
										:
										<tr>
											<td colSpan="2">
												{charityDeclMsg.noReportMsg}
											</td>
										</tr>
									}
									
								</tbody>
							</Table>
						</Card>
					</div>
				)}
				<Modal
					isOpen={this.state.modalIsOpen}
					onCancel={this.toggleModal}
					backdropClosesModal={true}
					showCloseModal={true}
					type="default"
				>
					<ModalHeader />
					<ModalBody>
						<Alert type="error" className="errorMsg">
							<strong>{charityDeclMsg.postErr}</strong>
							{charityDeclMsg.postErrMsg}
						</Alert>
						<div>
							<h2>{charityDeclMsg.disableMsg}</h2>
							<p>{charityDeclMsg.disableMsgConf}</p>
							<Button id="removeGA" onClick={this.removeGiftAid}>
								{charityDeclMsg.disableMsg}
							</Button>
						</div>
					</ModalBody>
					<ModalFooter />
				</Modal>
			</Container>
		);
	}
}
// GiftAidDeclaration.contextTypes = {
// 	router: PropTypes.object.isRequired
// };



// WEBPACK FOOTER //
// ./giftaid/components/charitydecl.js